import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

// Lazy‑loaded page components
const HomePage = lazy(() => import('../pages/home/page'));
const VenderCochePage = lazy(() => import('../pages/vender-coche/page'));
const VenderCocheSiniestroPage = lazy(() => import('../pages/vender-coche-siniestro/page'));
const VenderCocheAveriadoPage = lazy(() => import('../pages/vender-coche-averiado/page'));
const VenderCocheSinITVPage = lazy(() => import('../pages/vender-coche-sin-itv/page'));
const VenderCocheAccidentadoPage = lazy(() => import('../pages/vender-coche-accidentado/page'));
const TasacionCochePage = lazy(() => import('../pages/tasacion-coche/page'));

const DesguaceBarcelonaCiudadPage = lazy(() => import('../pages/desguace-barcelona-ciudad/page'));
const DesguaceBadalonaPage = lazy(() => import('../pages/desguace-badalona/page'));
const DesguaceHospitaletPage = lazy(() => import('../pages/desguace-hospitalet/page'));
const DesguaceSabadellPage = lazy(() => import('../pages/desguace-sabadell/page'));
const DesguaceTerrassaPage = lazy(() => import('../pages/desguace-terrassa/page'));
const DesguaceMataroPage = lazy(() => import('../pages/desguace-mataro/page'));
const DesguaceGranollersPage = lazy(() => import('../pages/desguace-granollers/page'));
const DesguaceVilafrancaPage = lazy(() => import('../pages/desguace-vilafranca/page'));
const DesguaceSantCugatPage = lazy(() => import('../pages/desguace-sant-cugat/page'));
const DesguaceCornellaPage = lazy(() => import('../pages/desguace-cornella/page'));
const DesguaceRubiPage = lazy(() => import('../pages/desguace-rubi/page'));
const DesguaceCastelldefelsPage = lazy(() => import('../pages/desguace-castelldefels/page'));
const DesguaceEspluguesPage = lazy(() => import('../pages/desguace-esplugues/page'));
const DesguaceMolletPage = lazy(() => import('../pages/desguace-mollet/page'));
const DesguaceSantAdriaPage = lazy(() => import('../pages/desguace-sant-adria/page'));
const DesguaceMontgatPage = lazy(() => import('../pages/desguace-montgat/page'));
const DesguaceSantaColomaPage = lazy(() => import('../pages/desguace-santa-coloma/page'));
const DesguaceCerdanyolaPage = lazy(() => import('../pages/desguace-cerdanyola/page'));
const DesguaceBarberaPage = lazy(() => import('../pages/desguace-barbera/page'));
const DesguaceRipolletPage = lazy(() => import('../pages/desguace-ripollet/page'));
const DesguaceMontcadaPage = lazy(() => import('../pages/desguace-montcada/page'));
const DesguaceGavaPage = lazy(() => import('../pages/desguace-gava/page'));
const DesguaceSantBoiPage = lazy(() => import('../pages/desguace-sant-boi/page'));
const DesguaceElPratPage = lazy(() => import('../pages/desguace-el-prat/page'));
const DesguaceViladecansPage = lazy(() => import('../pages/desguace-viladecans/page'));
const DesguaceCastellbisbalPage = lazy(() => import('../pages/desguace-castellbisbal/page'));
const DesguaceMartorellPage = lazy(() => import('../pages/desguace-martorell/page'));
const DesguaceSantAndreuBarcaPage = lazy(() => import('../pages/desguace-sant-andreu-barca/page'));
const DesguacePremiaDeMarPage = lazy(() => import('../pages/desguace-premia-de-mar/page'));
const DesguaceVilassarDeMarPage = lazy(() => import('../pages/desguace-vilassar-de-mar/page'));
const DesguaceIgualadaPage = lazy(() => import('../pages/desguace-igualada/page'));
const DesguaceManresaPage = lazy(() => import('../pages/desguace-manresa/page'));

const ZonasPage = lazy(() => import('../pages/zonas/page'));

const PrivacidadPage = lazy(() => import('../pages/privacidad/page'));
const TerminosPage = lazy(() => import('../pages/terminos/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Route configuration
const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/vender-coche-barcelona', element: <VenderCochePage /> },
  { path: '/vender-coche-siniestro-barcelona', element: <VenderCocheSiniestroPage /> },
  { path: '/vender-coche-averiado-barcelona', element: <VenderCocheAveriadoPage /> },
  { path: '/vender-coche-sin-itv-barcelona', element: <VenderCocheSinITVPage /> },
  { path: '/vender-coche-accidentado-barcelona', element: <VenderCocheAccidentadoPage /> },
  { path: '/tasacion-coche-barcelona', element: <TasacionCochePage /> },

  { path: '/desguace-barcelona-ciudad', element: <DesguaceBarcelonaCiudadPage /> },
  { path: '/desguace-badalona', element: <DesguaceBadalonaPage /> },
  { path: '/desguace-hospitalet', element: <DesguaceHospitaletPage /> },
  { path: '/desguace-sabadell', element: <DesguaceSabadellPage /> },
  { path: '/desguace-terrassa', element: <DesguaceTerrassaPage /> },
  { path: '/desguace-mataro', element: <DesguaceMataroPage /> },
  { path: '/desguace-granollers', element: <DesguaceGranollersPage /> },
  { path: '/desguace-vilafranca', element: <DesguaceVilafrancaPage /> },
  { path: '/desguace-sant-cugat', element: <DesguaceSantCugatPage /> },
  { path: '/desguace-cornella', element: <DesguaceCornellaPage /> },
  { path: '/desguace-rubi', element: <DesguaceRubiPage /> },
  { path: '/desguace-castelldefels', element: <DesguaceCastelldefelsPage /> },
  { path: '/desguace-esplugues', element: <DesguaceEspluguesPage /> },
  { path: '/desguace-mollet', element: <DesguaceMolletPage /> },
  { path: '/desguace-sant-adria', element: <DesguaceSantAdriaPage /> },
  { path: '/desguace-montgat', element: <DesguaceMontgatPage /> },
  { path: '/desguace-santa-coloma', element: <DesguaceSantaColomaPage /> },
  { path: '/desguace-cerdanyola', element: <DesguaceCerdanyolaPage /> },
  { path: '/desguace-barbera', element: <DesguaceBarberaPage /> },
  { path: '/desguace-ripollet', element: <DesguaceRipolletPage /> },
  { path: '/desguace-montcada', element: <DesguaceMontcadaPage /> },
  { path: '/desguace-gava', element: <DesguaceGavaPage /> },
  { path: '/desguace-sant-boi', element: <DesguaceSantBoiPage /> },
  { path: '/desguace-el-prat', element: <DesguaceElPratPage /> },
  { path: '/desguace-viladecans', element: <DesguaceViladecansPage /> },
  { path: '/desguace-castellbisbal', element: <DesguaceCastellbisbalPage /> },
  { path: '/desguace-martorell', element: <DesguaceMartorellPage /> },
  { path: '/desguace-sant-andreu-barca', element: <DesguaceSantAndreuBarcaPage /> },
  { path: '/desguace-premia-de-mar', element: <DesguacePremiaDeMarPage /> },
  { path: '/desguace-vilassar-de-mar', element: <DesguaceVilassarDeMarPage /> },
  { path: '/desguace-igualada', element: <DesguaceIgualadaPage /> },
  { path: '/desguace-manresa', element: <DesguaceManresaPage /> },

  { path: '/zonas', element: <ZonasPage /> },

  { path: '/privacidad', element: <PrivacidadPage /> },
  { path: '/terminos', element: <TerminosPage /> },

  // Catch‑all route for 404 pages
  { path: '*', element: <NotFoundPage /> },
];

export default routes;
